/* eslint-disable */
import React from 'react';

export const Banner30DataSource = {
    wrapper: {className: 'banner3 k0qcuji2xa8-editor_css'},
    textWrapper: {
        className: 'banner3-text-wrapper k0qct9r6a-editor_css',
        children: [
            {
                name: 'nameEn',
                className: 'banner3-name-en k0qcth162j-editor_css',
                children: (
                    <>
                        <p>NEWS &amp;EVENTS</p>
                    </>
                ),
            },
            {
                name: 'slogan',
                className: 'banner3-slogan k0qcsufjqz-editor_css',
                children: '产品及服务',
                texty: true,
            },

        ],
    },
};



